import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getByBuyer } from '../../../actions/marketPlaceActions'
import PurchasesListView from '../../../containers/MarketPlace/PurchaseList/PurchasesList'
import localStorage from '../../../utils/hooks/useLocalStorage'

const PurchasesList = () => {
  const dispatch = useDispatch()
  const { purchases } = useSelector(state => state.marketPlace)
  const { userInfo } = useSelector(state => state.userInfo)
  useEffect(() => {

    
    let id = localStorage().getItem('idProfile');
      dispatch(getByBuyer(id))
    




  }, [userInfo])


  return (
    <PurchasesListView purchases={purchases} />
  )
}

export default PurchasesList